import { useEffect } from 'react';
import { authByTBank } from '../../http/userAPI';

const AuthComplete = () => {

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const localState = localStorage.getItem('tbank_state');
    const refirectPath = localStorage.getItem('tbank_redirect_path');
    const deviceUUID = document.cookie.replace(/(?:(?:^|.*;\s*)mindboxDeviceUUID\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    const userAgent = window.navigator.userAgent;

    if (state !== localState) {
      console.error('CSRF ошибка: state не совпадает');
      return;
    }

    authByTBank(code, process.env.REACT_APP_TID_REDIRECT_URI, deviceUUID, userAgent)
      .then((response) => {
        if (response && !response.error) {
          window.location.href = refirectPath ? refirectPath : '/';
        }
      })
      .finally(() => {
        localStorage.removeItem('tbank_state');
        localStorage.removeItem('tbank_redirect_path');
      })
  }, []);

  return (<div>Завершаем авторизацию...</div>);
}

export default AuthComplete;